// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sugi 수기결제 페이지용 (필요 시 사용처에서 스타일 추가) */
`, "",{"version":3,"sources":["webpack://./src/Common/css/app.css"],"names":[],"mappings":"AAAA,uCAAuC","sourcesContent":["/* sugi 수기결제 페이지용 (필요 시 사용처에서 스타일 추가) */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
